import {call, put} from "redux-saga/effects";
import {
    excelExportSouscriptionsApi,
    generationBonCommandeSouscriptionsApi,
    getConsultationSouscriptionsListApi,
} from "../../../../common/apis/souscriptionApi";
import * as actions from "../state/consultationSouscriptionsActions";

export function* getConsultationSouscriptionsListSaga({ payload }) {
  try {
    const response = yield call(getConsultationSouscriptionsListApi, payload);
    yield put(
      actions.getConsultationSouscriptionsListSuccessAction(response.data.body)
    );
  } catch (error) {
    yield put(actions.getConsultationSouscriptionsListFailAction(error));
  }
}
export function* excelExportSouscriptionSaga({ payload }) {
  try {
    const response = yield call(excelExportSouscriptionsApi, payload);
    yield put(actions.printSuccess(response.data));
  } catch (error) {
    yield put(actions.printFail(error));
  }
}

export function* generationBonCommandeSouscriptionSaga({ payload }) {
  try {
    const response = yield call(generationBonCommandeSouscriptionsApi, payload);
    yield put(actions.generationBonCommandeSouscriptionSuccess(response.data));
  } catch (error) {
    yield put(actions.generationBonCommandeSouscriptionFail(error));
  }
}
